import AppDispatcher from "../dispatcher/AppDispatcher";

import AppConstants from "../constants/AppConstants";

// FeatureFlagActions
export default
{
	initialize(featureFlags, features)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.FEATURE_RECEIVE_DATA,
			featureFlags,
			features
		});
	}
};



// WEBPACK FOOTER //
// ./Components/actions/FeatureFlagActions.jsx